import { atom } from 'jotai';
import { unwrap } from 'jotai/utils';
import { PHYSICAL_SOURCE } from '@/types/metric';
import { hasMetricTranslation } from '@/utils/metrics';
import { metricDefinitionsAtom } from '../queries/metric';

export const playerMetricsAtom = atom(async get =>
  (await get(metricDefinitionsAtom)).filter(
    metricDefinition => metricDefinition.player && hasMetricTranslation(metricDefinition.key),
  ),
);

export const playerEventMetricsAtom = atom(async get =>
  (await get(playerMetricsAtom)).filter(metricDefinition => metricDefinition.source !== PHYSICAL_SOURCE),
);

export const unwrappedPlayerMetricsAtom = unwrap(playerMetricsAtom, prev => prev || []);
